const smoothscroll = require('smoothscroll-polyfill');
const BrowseHappy = require('./src/helpers/browse-happy');

exports.onRouteUpdate = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('off-canvas-active');
};

// Polyfills für IE 10 (@see https://github.com/gatsbyjs/gatsby/issues/2177#issuecomment-382280801)
// React braucht diese Polyfills, und die werden nicht automatisch von Babel gepolyfilled, da es in
// node_modules hängt.
require('core-js/es/set');
require('core-js/es/map');
require('core-js/es/object/entries');
require('core-js/es/string/starts-with');
require('core-js/es/array/from');

// IO Polyfill für Safari und iOS
// https://caniuse.com/#feat=intersectionobserver
require('intersection-observer');

exports.onClientEntry = () => {
    BrowseHappy.browseHappy();
    smoothscroll.polyfill();
};
